import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FiAward, FiStar, FiBookOpen } from 'react-icons/fi'
import apiInstance from '../../../../../Utils/api'
import BranchBadge from '../../branch/shared/BranchBadge'
import BranchButton from '../../branch/shared/BranchButton'
import BranchImageThumb from '../../branch/shared/BranchImageThumb'
import BranchBreadcrumb from '../../branch/shared/BranchBreadcrumb'
import '../../branch/branch.css'
import '../staff.css'

export default function StaffDetail() {
  const location = useLocation()
  const ID = location.pathname.split('/')[2]
  const [staff, setStaff] = useState(null)

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await apiInstance.get('staff/' + ID)
        setStaff(res.data.data)
      } catch (err) {
        console.error(err)
      }
    }
    fetchDetail()
  }, [ID])

  if (!staff) {
    return (
      <div className='branch-page'>
        <div className='branch-empty'><div className='branch-empty-title'>Loading...</div></div>
      </div>
    )
  }

  return (
    <div className='branch-page'>
      <BranchBreadcrumb items={[
        { label: 'Staff', to: '/staff' },
        { label: staff.title + ' ' + staff.name }
      ]} />

      <div className='branch-hero'>
        <div style={{ display: 'flex', alignItems: 'center', gap: 24, padding: 24 }}>
          <BranchImageThumb src={staff.imageUrl} alt={staff.name} />
          <div style={{ flex: 1 }}>
            <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 700 }}>
              <span className='staff-title-label'>{staff.title} </span>
              <span className='staff-title-name'>{staff.name}</span>
            </h1>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
              <span className={`staff-role-badge staff-role-${staff.role}`}>{staff.role}</span>
              <BranchBadge status={staff.isDeleted ? 'Deleted' : 'Active'} />
              {staff.isActive && <span style={{ fontSize: '0.8rem', color: '#059669', background: '#d1fae5', padding: '2px 10px', borderRadius: 50 }}>Visible on website</span>}
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--branch-text)' }}>{staff.displayOrder || 0}</div>
            <div style={{ fontSize: '0.75rem', color: 'var(--branch-text-muted)' }}>Display Order</div>
          </div>
        </div>
      </div>

      <div className='branch-info-grid'>
        <div className='branch-info-card'>
          <div className='branch-info-card-title'><FiAward size={14} /> Qualifications</div>
          {staff.qualifications?.length > 0 ? (
            <ul style={{ margin: 0, paddingLeft: 20, lineHeight: 2 }}>
              {staff.qualifications.map((q, i) => <li key={i} className='branch-info-content'>{q}</li>)}
            </ul>
          ) : (
            <div className='branch-info-content'>Not provided</div>
          )}
        </div>

        <div className='branch-info-card'>
          <div className='branch-info-card-title'><FiStar size={14} /> Specialties</div>
          {staff.specialties?.length > 0 ? (
            <ul style={{ margin: 0, paddingLeft: 20, lineHeight: 2 }}>
              {staff.specialties.map((s, i) => <li key={i} className='branch-info-content'>{s}</li>)}
            </ul>
          ) : (
            <div className='branch-info-content'>Not provided</div>
          )}
        </div>
      </div>

      <div className='branch-info-card' style={{ marginTop: 24 }}>
        <div className='branch-info-card-title'><FiBookOpen size={14} /> Biography</div>
        <div className='branch-info-content'>{staff.biography || 'No biography provided.'}</div>
      </div>

      <div style={{ marginTop: 24, display: 'flex', gap: 12 }}>
        <Link to='/staff'><BranchButton variant='outline'>Back to List</BranchButton></Link>
        <Link to={'/staff-update/' + staff._id}><BranchButton>Edit Staff</BranchButton></Link>
      </div>
    </div>
  )
}
